import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = {
	auth: true
}

export default {
	path: '/activity',
	name: 'activity',
	meta,
	redirect: {
		name: 'activity-index'
	},
	component: layoutHeaderAside,
	children: (pre => [
		{
			path: 'activityList',
			name: `${pre}activityList`,
			component: _import('activity/activityList'),
			meta: {
				...meta,
				title: '活动列表'
			}
		},
	])('activity-')
}